module.exports = __webpack_public_path__ + "img/3plates.b0eda785.svg";